// Official YouTube icon, traced from the vector asset shipped in the YouTube brand kit
// (YouTube_Icon/Digital/01 Red/yt_icon_red_digital.ai). The branding guidelines forbid altering its
// shape, proportions or colors, and require a rendered height of at least 20dp — hence the
// hardcoded fills and the floor on the height prop. Note the brand red is #FF0033, not #FF0000.
// https://developers.google.com/youtube/terms/branding-guidelines
const MIN_HEIGHT = 20

// Tight bounding box of the mark inside the source artwork, so that `height` is the height of the
// icon itself rather than of the artboard and its clear space.
const VIEW_BOX = '102.6875 119.168 396 277.402'
const ASPECT_RATIO = 396 / 277.402

type LXYoutubeIconProps = {
  height?: number
}

export const LXYoutubeIcon = ({ height = MIN_HEIGHT }: LXYoutubeIconProps) => {
  const iconHeight = Math.max(height, MIN_HEIGHT)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={VIEW_BOX}
      height={iconHeight}
      width={iconHeight * ASPECT_RATIO}
      style={{ flexShrink: 0 }}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#FF0033"
        fillRule="nonzero"
        d="M 261.203125 317.3125 L 363.890625 257.722656 L 261.203125 198.425781 Z M 146.078125 388.179688 C 129.011719 383.550781 115.707031 369.957031 110.789062 353.179688 C 102.6875 322.226562 102.6875 257.722656 102.6875 257.722656 C 102.6875 257.722656 102.6875 193.21875 110.789062 162.558594 C 115.707031 145.492188 129.011719 132.183594 146.078125 127.554688 C 176.738281 119.167969 300.542969 119.167969 300.542969 119.167969 C 300.542969 119.167969 424.636719 119.167969 455.296875 127.554688 C 472.652344 132.183594 485.667969 145.492188 490.296875 162.558594 C 498.6875 193.21875 498.6875 257.722656 498.6875 257.722656 C 498.6875 257.722656 498.6875 322.226562 490.296875 353.179688 C 485.667969 369.957031 472.652344 383.550781 455.296875 388.179688 C 424.636719 396.570312 300.542969 396.570312 300.542969 396.570312 C 300.542969 396.570312 176.738281 396.570312 146.078125 388.179688 "
      />
      <path
        fill="#FFFFFF"
        fillRule="nonzero"
        d="M 261.203125 317.3125 L 363.890625 257.722656 L 261.203125 198.425781 Z M 261.203125 317.3125 "
      />
    </svg>
  )
}
